import { useApolloClient } from "@apollo/client";
import gql from "graphql-tag";
import { useAppState } from "../../hooks/useAppState";
import { ReadOutline, ReadOutline_course } from "./__generated__/ReadOutline";

export const READ_OUTLINE_QUERY = gql`
  query ReadOutline($courseId: Int!) {
    course(courseId: $courseId) {
      sections {
        id
        name
        progress @client {
          percent
          percentSlides
        }
        modules {
          id
          name
          type
          quizInProgress
          quizScore
          confidenceRating {
            rating
          }
          progress @client {
            isViewed
            total
          }
        }
      }
    }
  }
`;

export function useOutlineQuery(): { loading: boolean; outline?: ReadOutline_course } {
  const {
    appState: { courseId },
  } = useAppState();
  const client = useApolloClient();

  const outline = client.readQuery<ReadOutline>({
    query: READ_OUTLINE_QUERY,
    variables: { courseId },
  });

  if (!outline) return { loading: true };

  return { loading: false, outline: outline?.course };
}
